import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { catalogueApi } from '../services/api';
import { CatalogueShell, Spinner } from '../components/catalogue/CatalogueShell';
import { CATEGORY_LINKS } from '../components/catalogue/CatalogueNav';
import { CatalogueFilters } from '../components/catalogue/CatalogueFilters';
import { ProductGrid } from '../components/catalogue/ProductCard';
import { Pagination } from '../components/catalogue/Pagination';

const PAGE_SIZE = 30;

export default function CatalogueCategoryPage() {
  const { brandId, category = '' } = useParams();
  const [params, setParams] = useSearchParams();
  const q = params.get('q') || '';
  const page = parseInt(params.get('page') || '1', 10);
  const filters = { finish: params.get('finish') || '', size: params.get('size') || '', ip44: params.get('ip44') === '1' };
  const [data, setData] = useState(null);
  const label = CATEGORY_LINKS.find((c) => c.slug === category)?.label;

  useEffect(() => {
    setData(null);
    catalogueApi
      .getAll(brandId, { page, limit: PAGE_SIZE, category, search: q, finish: filters.finish, size: filters.size, ip44: filters.ip44 })
      .then((r) => setData(r.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId, category, q, page, filters.finish, filters.size, filters.ip44]);

  const update = (next) => {
    const p = new URLSearchParams();
    if (q) p.set('q', q);
    if (next.finish) p.set('finish', next.finish);
    if (next.size) p.set('size', next.size);
    if (next.ip44) p.set('ip44', '1');
    if (next.page > 1) p.set('page', String(next.page));
    setParams(p);
    if (next.page) window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const title = q ? `Search: “${q}”` : label || 'All lighting';
  const crumbs = q
    ? [{ label: 'Lighting', to: `/brand/${brandId}/lighting` }, { label: 'Search' }]
    : [{ label: 'Lighting', to: `/brand/${brandId}/lighting` }, { label: title }];

  return (
    <CatalogueShell brandId={brandId} crumbs={crumbs} title={title} query={q} testId="catalogue-category-page"
      intro={data ? `${data.total} ${data.total === 1 ? 'product' : 'products'}` : ''}>
      {data && <CatalogueFilters facets={data.facets} filters={filters} onChange={(f) => update({ ...f, page: 1 })} />}
      {!data ? <Spinner /> : data.products.length ? (
        <>
          <ProductGrid brandId={brandId} products={data.products} subtitleFn={(p) => `${p.family} · ${p.productType}`} />
          <Pagination page={page} totalPages={data.totalPages} onPage={(p) => update({ ...filters, page: p })} />
        </>
      ) : (
        <p className="text-gray-500 py-16 text-center" data-testid="no-results">No products match. Try another search or clear the filters.</p>
      )}
    </CatalogueShell>
  );
}
